import { MutationObserverOptions, useMutation } from 'react-query';
import {
  deleteCancelRequestJoinGroup,
  postJoinGroup,
} from '../../apis/tms/feed.api';
import { FolderStatusEnum } from '../../interfaces/training.interface';

const useRequestAccessGroup = ({
  opt,
  isRequested,
}: {
  isRequested: boolean;
  opt?: Omit<
    MutationObserverOptions<unknown, Error, unknown, unknown>,
    '_defaulted' | 'variables'
  >;
}) => {
  const mutationReturn = useMutation({
    mutationFn: isRequested
      ? ({ groupId }: { groupId: string }) =>
          deleteCancelRequestJoinGroup(groupId)
      : ({
          groupId,
          groupStatus,
        }: {
          groupId: string;
          groupStatus: FolderStatusEnum;
        }) => postJoinGroup(groupId, groupStatus),
    ...opt,
  });

  return { mutationReturn };
};

export default useRequestAccessGroup;
